export default {
  certificate_title: 'Calibration Certificate',
  requestor_data: 'Requestor Data',
  contractor: 'Contractor',
  requester: 'Requester',
  order_service: 'Service Order',
  calibration_date: 'Calibration Date',
  receipt_date: 'Receipt Date',
  emission_date: 'Emission Date',
  equipment_data: 'Equipment Data',
  name: 'Name',
  manufacturer: 'Manufacturer',
  model: 'Model',
  serial_number: 'Serial Number',
  code: 'Code',
  type_indication: 'Type of Indication',
  software: 'Software',
  procedure: 'Procedure',
  results_table: 'Results Table',
  unit: 'Unit',
  indication_equipment: 'Indication of Calibrated Equipment',
  reference_value: 'Reference Value',
  measurement_error: 'Measurement Error',
  hysteresis: 'Hysteresis',
  uncertainty_measurement: 'Measurement Uncertainty',
  bias_chart: 'Bias Chart',
  traceability_standards: 'Traceability of Standards Used',
  calibration_location: 'Calibration Location',
  temperature: 'Temperature',
  relative_humidity: 'Relative Humidity',
  information: 'Informations',
  ambient_conditions: 'Environmental Conditions and Location',
  digital_authorization: 'Digital Authorization',
  authorized_signatory: 'Authorized Signatory',
  replaced_certificate: 'This certificate cancels and replaces certificate Nº.',
  settings: 'Settings',
  input_signal: 'Input Signal',
  smallest_graduation: 'Value of the smallest graduation',
  measurement_range: 'Measurement Range',
  certificate_code: 'certificate code',
  next_calibration_in: 'next calibration in',
  no_Equipment_type: 'No Equipment type',
  no_certificate: 'no certificate',
  of_preposition: 'of',
  inProgress: 'In Progress',
  canceled: 'Canceled',
  pending_signature: 'Pending Signature',
  calibration_point: 'Calibration Point',
  proc_26_obs: `The reported expanded measurement uncertainty is stated with standard measurement uncertainty multiplied by the coverage factor k, which for a distribution t with veff effective degrees of freedom corresponds to a coverage probability of approximately 95%. The standard measurement uncertainty was determined from in accordance with publication E A-4/02.

Measurement Error is obtained by the difference between the value indicated on the equipment being calibrated and the reference value

Hysteresis is the difference between the punctual indication errors of the scale of ascending and descending cycles

The temperature values presented are based on the 1990 International Temperature Scale (ITS-90)

Cgcre is a signatory to the ILAC Mutual Recognition Agreement - International Laboratory Accreditation Cooperation

This document is valid exclusively for the evaluated equipment, described in the specific conditions, and does not extend to any batches, even similar ones. Reproduction of this document is not permitted, only the original. Document checked and signed electronically.`,
  section_7_incerteza:
    'The reported expanded measurement uncertainty is stated with standard measurement uncertainty multiplied by the coverage factor k, which for a distribution t with veff effective degrees of freedom corresponds to a coverage probability of approximately 95%. The standard measurement uncertainty was determined from in accordance with publication E A-4/02.',
  section_7_erro_medicao:
    'Measurement Error is obtained by the difference between the value indicated on the equipment being calibrated and the reference value',
  section_7_values_temperature:
    'The temperature values ​​presented are based on the 1990 International Temperature Scale (ITS-90)',
  section_7_signature:
    'Cgcre is a signatory to the ILAC Mutual Recognition Agreement - International Laboratory Accreditation Cooperation',
  section_7_valid_document:
    'This document is valid exclusively for the evaluated equipment, described in the specific conditions, and does not extend to any batches, even similar ones. Reproduction of this document is not permitted, only the original. Document checked and signed electronically.',
  sensor_diameter: 'Sensor Diameter',
  sensor_length: 'Sensor Length',
  immersion_depht: 'immersion depht',
  spectral_range: 'Spectral Range',
  proportion_ds: 'Proportion D:S',
  distance: 'Distance',
  size: 'Size',
  type: 'Type',
  calculated_constant: 'calculated constant',
  sensor_code: 'Sensor code',
  seccion_diameter: 'Seccion Diameter',
  emissivity: 'Emissivity',
  gravity_acceleration: 'Gravity Acceleration',
  air_density: 'Air Density',
  atmospheric_pressure: 'Atmospheric pressure',
  standard_temperature: 'Standard Temperature',
  standard_pressure: 'Standard Pressure',
  operation_principle: 'Operation principle',
  standard: 'Standard',
  classe: 'Classe',
  frequence: 'Frequence',
  nominal_value: 'Nominal Value',
  lower_limit: 'Lower Limit',
  upper_limit: 'Upper Limit',
  connection: 'Connection',
  imersion: 'Imersion',
  thermometric_liquid: 'Thermometric Liquid',
  estimated_resolution: 'Estimated Resolution',
  sensor_temperature: 'Sensor',
  material: 'Material',
  sample_material: 'Material da Amostra',
  batch: 'Batch',
  resolution: 'Resolution',
  measuring_position: 'Measuring Position',
  position: 'Position',
  indicacao_item_calibrado: "Indication of the calibrated item",
  erro_histerese: "The hysteresis error is obtained by the greatest difference between the errors, in the forward and return directions, at the same point on the scale.",
  erro_sentido_avanco: "The forward direction error is obtained by the difference between the maximum and minimum errors, considering only the forward direction (inward) of the mobile rod.",
  erro_sentido_avanco_retorno: "The error in the forward and return directions is obtained by the difference between the maximum and minimum errors, considering the forward (inward) and return (outward) directions of the instrument's movable rod",
  calibration_temperature: 'Calibration Temperature',
  simulation_temperature: 'Simulation Temperature',
  reference_information: 'Reference Information',
  indicador_data: 'Indicador Data',
  electrode_data: 'Electrode Data',
  technical_specification_standard: 'Technical Specification Standard',
  reference_sound_pressure_level: 'Reference Sound Pressure Level',
  microphone_data: 'Microphone Data',
  preamplifier_data: 'Preamplifier Data',
  limit: 'Limit',
  detour: 'Detour',

  secction_7_additional_information:
    'Additional information regarding calibration conditions',
  reference_standard_for_calibration: 'Reference standard for calibration',
  self_generated_noise_microphone_installed:
    'Self-generated noise Microphone installed',
  c_weighted_frequency_with_microphone_installed:
    'C-weighted Frequency with Microphone installed',
  c_weighted_frequency: 'C-weighted Frequency',
  a_weighted_frequency: 'A-weighted Frequency',
  level_linearity_on_the_reference_level_range:
    'Level Linearity on the reference level range',
  toneburst_response_fast: 'Toneburst response - Fast',
  toneburst_response_slow: 'Toneburst response - Slow',
  c_weighted_peak_sound_level_8_Hz: 'C-weighted peak sound level 8 kHz',
  c_weighted_peak_sound_level_500_Hz: 'C-weighted peak sound level 500 kHz',
  overload_indication: 'Overload indication',
  self_generated: 'Self-generated',
  frequency_and_time_weightings_at_1_kHz:
    'Frequency and time weightings at 1 kHz',
  cell_constant: 'Cell Constant',
  ph_simulation: 'pH Simulation',
  unit_measurement: 'Unit of Measurement',
  obtaining_the_value_of_the_conductivity_cell_constant_kcal:
    'Obtaining the value of the conductivity cell constant (Kcal))',
  obtaining_conductivity_with_mcr: 'Obtaining conductivity with MRC',
  mrc_reference_value: 'MRC reference value',
  commercial_conductivity_cell_constant_value_kcel:
    'Commercial conductivity cell constant value kcel',
  conductivity_cell_constant_value_obtained_after_kcal_calibration:
    'Conductivity cell constant value obtained after kcal calibration',
  section_7_conductivity_cell_constant_kcel_commercial_conductivity_cell_constant_value:
    'Conductivity cell constant (Kcel): Commercial conductivity cell constant value',
  section_7_conductivity_cell_constant_kcal_cell_constant_value_obtained_after_calibration_with_mrc:
    'Conductivity cell constant (Kcal): Cell constant value, obtained after calibration with MRC',
  vertical_resolution: 'Vertical Resolution',
  horizontal_resolution: 'Horizontal Resolution',
  channel: 'Channel',
  specification: 'Specification',
  value_obtained: 'Value obtained',
  distance_from_nominal_value: 'Distance from nominal value',
  thermal_expansion_coefficient: 'Thermal expansion coeficient',
  quantity_items: 'Quantity of items',
  nominal_lenght_lc: 'Nominal lenght Ln',
  length_obtained: 'Lenght obtained',
  error_lc: 'Error Lc - Ln',
  value_division: 'Value of a division',
  item: 'Item',
  circularityChart: 'Roundness Chart',
  length_indications: 'Length indications',
  shape_and_position: 'Shape and position parameters of measuring surfaces',
  evaluated_parameter: 'Evaluated parameter',
  surface_flatness_fixed_side: 'Surface flatness on the fixed side',
  surface_flatness_moving_side: 'Surface flatness on the moving side',
  surface_parallelism: 'Surface parallelism',
  nominal_length: 'Nominal length',
  length_obtained_central: 'Length obtained in the central region',
  maximum_minimum_deviations:
    'Maximum and minimum deviations from the nominal length',
  perpendicularity_diagram: 'Perpendicularity diagram',
  applicant_and_service_data: 'Instrument and Requestor Data',
  type_of_square: 'Type of item',
  direction_and_side_of_surface: 'Direction and side of surface',
  length_evaluated: 'Length evaluated',
  item_type: 'Item type/classification',
  project_code: 'Project code',
  overall_dimensions: 'Overall dimensions',
  side: 'Side',
  nominal_diameter: 'Nominal diameter',
  maximum_variation: 'Maximum variation',
  average_affective_diameter_of_the_three_wires:
    'Average effective diameter of the three wires',
  results_of_inquiries: 'Indication results',
  transducer_serial_number: 'Transducer Serial Number',
  indicator_serial_number: 'Indicator Serial Number',
  type_of_material: 'Type of material',
  applied_traction_force: 'Applied traction force',
  comparator_measuring_range: 'Comparator measuring range',
  amplifier_measuring_range: 'Amplifier measuring range',
  standard_deviation: 'Standard deviation',
  amplifier_serial_number: 'Amplifier serial number',
  results_evaluated_parameters: 'Results of the evaluated parameters',
  flank_diameter: 'Flank diameter',
  step: 'Step',
  go: 'Go',
  fillet_angle: 'Fillet angle',
  diameter_variation: 'Diameter variation',
  scheme: 'Scheme',
  circularity_error: 'Circularity error',
  angle_indications: 'Angle indications',
  doesnt_pass: `Doesn't pass`,
  repeatability_error: 'Repeatability error',
  hysteresis_error: 'Hysteresis error',
  feed_direction_error: 'Feed direction error',
  forward_return_direction_error: 'Forward and return direction error',
  orientative_diagram:
    'Orientative Diagram of the Distribution of Calibrated Points and Positions',
  incerteza: 'Uncertainty',
  media: 'Average',
  arredondamento: 'Rounding',
  valorMenorDivisao: 'Value of the smallest division',
  valor_menor_dvisao: 'Value of the smallest graduation',
  valorMenorDivisaoPercent: 'Value of the smallest division',
  valueSmallestGraduationPercent: 'Value of the smallest graduation',
  faixa_medicao_espectral: 'Spectral measurement range',
  largura_banda: 'Bandwidth',
  velocidade_varredura: 'Scanning speed',
  comprimento_onda_nm: 'Wavelength, in nm',
  escala_fotometrica_uv: 'Ultra violet (UV) photometric scale, in absorbance',
  escala_fotometrica_vis: 'Visible photometric scale (VIS), in absorbance',
  afastamento_valor_nominal:
    'The deviation from the nominal value is obtained by the difference between the value obtained by measurements carried out by the laboratory standard and the nominal value.',
  imagens_item_medido: 'Images of the measured item:',
  projeto_item_medido: 'Measured item design:',
  tabela_resultados_detalhada: 'Detailed results table:',
  especificacao: 'Specification',
  erro_medicao:
    'The measurement error is obtained by the difference between the value obtained by the laboratory standard and the nominal value of the evaluated item.',
  valor_divisao: 'Value of a division:',
  intervalo_medicao: 'Measurement range:',
  erro_adjacente:
    'The adjacent error is obtained by the difference in values between consecutive points.',
  erro_repetitividade:
    'The repeatability error is obtained by the maximum variation in a series of three consecutive measurements.',
  configuracao: 'Configuration',
  software_indicador: 'Indicator software',
  versao_software_indicador: 'Indicator software version',
  numero_serie_indicador: 'Indicator serial number',
  erro_medicao_equipamento:
    'The measurement error is obtained by the difference between the indicated value of the evaluated equipment and the reference value.',
  classe_exatidao: 'Accuracy class',
  tipo_balanca: 'Scale type',
  tipo_auto_ajuste: 'Type of auto adjustment',
  calibracao_excentricidade: 'Eccentricity calibration',
  imagens_orientativas_excentricidade:
    'Guiding images of measurement positions in eccentricity calibration',
  desvio_padrao_informado:
    'The reported standard deviation corresponds to the average of the readings taken at each calibrated point.',
  atividade_ajuste_reparo:
    'The adjustment or repair activity, when performed, is not part of the laboratory’s accreditation scope.',
  calibracao_nao_isenta_controle:
    'This calibration does not exempt the instrument from metrological control established by metrological regulations.',
  material_amostra: 'Sample Material',
  volume: 'Volume',
  codigo: 'Code',
  histerese:
    'Hysteresis is the difference between the point indication errors of the scale in ascending and descending cycles.',
  tipo_escala: 'Scale type',
  tipo_nomenclatura: 'Nomenclature type',
  resolucao_adotada: 'Adopted resolution',
  sentidos_horario_antihorario:
    "The clockwise and counterclockwise directions were defined by observing the level from the front, following the manufacturer's descriptions and/or code.",
  zero_inversao:
    'The zero inversion was obtained through measurements taken in the front position (0°) and the rear (inverted 180°) of the instrument.',
  numero_serie_apalpador: 'Probe Serial Number',
  numero_serie_braco: 'Arm Serial Number',
  ruido_fundo:
    'The background noise corresponds to the influence of the measurement system and the surrounding environment. It was determined using a reference optical plane, where its results are used in the uncertainty calculations of roughness parameters.',
  diagrama_orientativo_distribuicao:
    'Guiding diagram of the distribution of calibrated points and positions',
  tipo_perfil_rugosidade: 'Type of roughness profile',
  abertura_nominal: 'Nominal opening',
  diametro_fio_nominal: 'Nominal wire diameter',
  sentido_medicao_horizontal:
    'The horizontal measurement direction (X) is parallel to the sieve description, identified on the frame.',
  classe_declarada: 'Declared class',
  regiao_parametro: "Region or Parameter",
  retrological_characteristics_presented_by_the_instrument: 'retrological characteristics presented by the instrument.',
};
